module.exports = __webpack_public_path__ + "static/redbull-f31550db1a992ed490ddfa5395ee9d1f.png";